export default __webpack_public_path__ + "static/media/calculating-loans.787521f4.svg";